import React, {useEffect, useState} from 'react';
import { useGameDetailConfig } from "../../context/GameDetailConfig";
import './Title.css';

const Title = ({ gameId, className }) => {
    const [roomName, setRoomName] = useState('');
    const { gameDetailConfig } = useGameDetailConfig();

    useEffect(() => {
        if (gameDetailConfig && gameDetailConfig.title) {
            // Fetch the room name dynamically based on gameId
            setRoomName(gameDetailConfig.title); // Example logic
        } else {
            setRoomName('Loading...');
        }
    }, [gameDetailConfig, gameId]);

    return (
        <h3 className={className ?? "title"}>{roomName}</h3>
    );
};

export default Title;
